import { useEffect } from "react";
import { BRAND } from "@/lib/site";

const setMeta = (name, content, attr = "name") => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setLink = (rel, href) => {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

const setJsonLd = (data) => {
    let el = document.head.querySelector('script[data-jsonld="lbp"]');
    if (!el) {
        el = document.createElement("script");
        el.setAttribute("type", "application/ld+json");
        el.setAttribute("data-jsonld", "lbp");
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
};

export default function useSEO({ title, description, image, jsonLd } = {}) {
    useEffect(() => {
        const fullTitle = title ? `${title} · ${BRAND}` : `${BRAND} · Mobile Mechanic — Hampton Roads, VA`;
        document.title = fullTitle;
        setMeta("description", description);
        setMeta("og:title", fullTitle, "property");
        setMeta("og:description", description, "property");
        setMeta("og:type", "website", "property");
        setMeta("og:image", image, "property");
        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", fullTitle);
        setMeta("twitter:description", description);
        setMeta("twitter:image", image);
        setLink("canonical", typeof window !== "undefined" ? window.location.href : null);
        if (jsonLd) setJsonLd(jsonLd);
    }, [title, description, image, JSON.stringify(jsonLd || {})]);
}
